import { gql } from "@apollo/client";

export const SIGNUP_USER = gql`
  mutation insert_owner(
    $email: String!
    $first_name: String!
    $last_name: String!
    $password: String!
    $phone: String!
  ) {
    insert_owner(
      object: {
        email: $email
        first_name: $first_name
        password: $password
        last_name: $last_name
        phone: $phone
      }
    ) {
      user_id
      access_token
    }
  }
`;

export const VERIFY_OTP = gql`
  mutation verifyotp($user_id: String!, $otp: String!) {
    verify_otp(user_id: $user_id, otp: $otp) {
      message
      status
    }
  }
`;

export const RESEND_OTP = gql`
  mutation resendotp($token: String!) {
    resend_otp(token: $token) {
      message
      status
    }
  }
`;

export const INSERT_BUSINESS = gql`
  mutation insertBusiness(
    $owner_id: uuid!
    $location_count: Int!
    $business_type_id: uuid!
    $business_name: String!
    $referral_code: String
  ) {
    business: insertOneBusiness(
      object: {
        business_name: $business_name
        business_type_id: $business_type_id
        location_count: $location_count
        owner_id: $owner_id
        ref_code: $referral_code
      }
    ) {
      business_id
    }
  }
`;

export const UPDATE_BUSINESS = gql`
  mutation updateBusiness(
    $business_id: uuid!
    $business_name: String!
    $business_type_id: uuid!
    $location_count: Int!
    $owner_id: uuid!
    $referral_code: String
  ) {
    business: updateBusinessById(
      pk_columns: { business_id: $business_id }
      _set: {
        business_name: $business_name
        business_type_id: $business_type_id
        owner_id: $owner_id
        location_count: $location_count
        ref_code: $referral_code
      }
    ) {
      business_id
      business_name
      location_count
      business_type_id
      owner_id
    }
  }
`;

export const UPDATE_USER_LAST_SCREEN = gql`
  mutation updateLastScreen($last_screen: String!, $user_id: uuid!) {
    userDetail: updateUsersById(
      pk_columns: { user_id: $user_id }
      _set: { last_screen: $last_screen }
    ) {
      last_screen
    }
  }
`;

export const LOGIN_USER = gql`
  mutation login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      access_token
      id
      loggedInUser {
        last_screen
        userRole: user_location_maps {
          jobRoleDetails {
            access_type
          }
        }
        is_phone_verified
        is_password_reset
        is_super_admin
      }
    }
  }
`;

export const INSERT_LOCATION = gql`
  mutation insertLocations($objects: [user_location_map_insert_input!]!) {
    insertUserLocationMaps(objects: $objects) {
      affected_rows
      returning {
        location_id
      }
    }
  }
`;

export const DELETE_EMPLOYEE_COUNT = gql`
  mutation delete_employee_count(
    $business_id: uuid!
    $job_role_id: uuid!
    $location_id: uuid!
  ) {
    delete_location_user_count_map_by_pk(
      business_id: $business_id
      job_role_id: $job_role_id
      location_id: $location_id
    ) {
      location_id
    }
  }
`;

export const UPSERT_EMPLOYEE_COUNT = gql`
  mutation insert_location_user_count_map(
    $objects: [location_user_count_map_insert_input!]!
  ) {
    insert_location_user_count_map(
      objects: $objects
      on_conflict: {
        constraint: location_user_count_map_pkey
        update_columns: count
      }
    ) {
      affected_rows
    }
  }
`;

export const CONFIRM_USER_DETAILS = gql`
  mutation updateUsersById($email: String, $phone: String, $user_id: uuid!) {
    updateUsersById(
      pk_columns: { user_id: $user_id }
      _set: { phone: $phone, email: $email }
    ) {
      user_id
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation reset_user_password($password: String!, $user_id: String!) {
    reset_user_password(password: $password, user_id: $user_id) {
      message
      status
    }
  }
`;

export const INSERT_EMPLOYEE_REPORTING = gql`
  mutation insertEmployeeReporting(
    $objects: [user_reporting_map_insert_input!]!
  ) {
    insert_user_reporting_map(objects: $objects) {
      returning {
        location_id
      }
    }
  }
`;

export const UPDATE_USER_NOTIFICATION = gql`
  mutation updateUsersById(
    $email_notifications: Boolean
    $phone_notifications: Boolean
    $user_id: uuid!
  ) {
    updateUsersById(
      pk_columns: { user_id: $user_id }
      _set: {
        send_email_notifications: $email_notifications
        send_phone_notifications: $phone_notifications
      }
    ) {
      send_email_notifications
      send_phone_notifications
    }
  }
`;
export const UPDATE_LOCATION_DATA = gql`
  mutation updateLocationById(
    $location_id: uuid!
    $location_update_fields: locations_set_input
    $closing_time: time
    $opening_time: time
  ) {
    updateLocationById(
      pk_columns: { location_id: $location_id }
      _set: $location_update_fields
    ) {
      updated_at
    }
    update_location_timing(
      where: { location_id: { _eq: $location_id } }
      _set: { closing_time: $closing_time, opening_time: $opening_time }
    ) {
      affected_rows
    }
  }
`;

export const INSERT_USER = gql`
  mutation insertUser($objects: [NewEmployeeInputs!]!) {
    insert_employees(objects: $objects) {
      status
    }
  }
`;

export const INSERT_ROLE_LOCATION_MAP = gql`
  mutation insertUserLocationMap(
    $user_id: uuid!
    $location_id: uuid!
    $job_role_id: uuid!
    $business_id: uuid!
  ) {
    insertUserLocationMaps(
      objects: {
        user_id: $user_id
        location_id: $location_id
        job_role_id: $job_role_id
        business_id: $business_id
      }
    ) {
      affected_rows
    }
  }
`;

export const DELETE_USER = gql`
  mutation deleteUser($user_id: uuid!, $business_id: uuid!) {
    deleteUserLocationMaps(
      where: { user_id: { _eq: $user_id }, business_id: { _eq: $business_id } }
    ) {
      affected_rows
    }
    deleteUsers(where: { user_id: { _eq: $user_id } }) {
      affected_rows
    }
  }
`;

export const UPDATE_USER_DETAILS = gql`
  mutation updateUserDetails($user_id: uuid!, $user_details: users_set_input!) {
    updateUsersById(pk_columns: { user_id: $user_id }, _set: $user_details) {
      user_id
    }
  }
`;

export const UPDATE_USER_SHIFT = gql`
  mutation update_user_shift(
    $user_id: uuid!
    $_set: user_shift_set_input = {}
  ) {
    update_user_shift(where: { user_id: { _eq: $user_id } }, _set: $_set) {
      returning {
        working_day
        start_time
        end_time
      }
    }
  }
`;

export const DELETE_USER_LOCATION_MAP = gql`
  mutation deleteUserLocationMap(
    $business_id: uuid!
    $job_role_id: uuid!
    $location_id: uuid!
    $user_id: uuid!
  ) {
    deleteOneUserLocationMap(
      business_id: $business_id
      job_role_id: $job_role_id
      location_id: $location_id
      user_id: $user_id
    ) {
      user_id
    }
  }
`;

export const INSERT_USER_REPORTING = gql`
  mutation insertUserReporting(
    $reportee_id: uuid!
    $reporter_id: uuid!
    $location_id: uuid!
  ) {
    insert_user_reporting_map_one(
      object: {
        reportee_id: $reportee_id
        reporter_id: $reporter_id
        location_id: $location_id
      }
    ) {
      created_at
    }
  }
`;

export const UPDATE_EMPLOYEE_DETAILS = gql`
  mutation updateEmployeeDetails(
    $user_id: uuid!
    $user_details: users_set_input!
    $shifts: [user_shift_insert_input!]!
  ) {
    delete_user_shift(where: { user_id: { _eq: $user_id } }) {
      affected_rows
    }
    updateUsersById(pk_columns: { user_id: $user_id }, _set: $user_details) {
      updated_at
    }
    insert_user_shift(objects: $shifts) {
      affected_rows
    }
  }
`;

export const INSERT_EMPLOYEES = gql`
  mutation insertUser($objects: [NewEmployeeInputs!]!) {
    insert_employees(objects: $objects) {
      status
    }
  }
`;
export const FILE_UPLOADS = gql`
  mutation generateUrl($fileName: String!, $fileType: String!) {
    generateUrl(fileName: $fileName, fileType: $fileType)
  }
`;

export const UPDATE_EMPLOYEES = gql`
  mutation updateEmployees(
    $user_id: uuid!
    $user_details: users_set_input!
    $user_shifts: [user_shift_insert_input!]!
  ) {
    delete_user_shift(where: { user_id: { _eq: $user_id } }) {
      affected_rows
    }
    updateUsersById(pk_columns: { user_id: $user_id }, _set: $user_details) {
      user_id
    }
    insert_user_shift(objects: $user_shifts) {
      affected_rows
    }
  }
`;

export const DELETE_REMOVED_EMP_REPORTEE = gql`
  mutation deleteRemovedEmpReportee(
    $location_id: uuid!
    $reporter_id: uuid!
    $reportee_ids: [uuid!]!
  ) {
    delete_user_reporting_map(
      where: {
        location_id: { _eq: $location_id }
        reporter_id: { _eq: $reporter_id }
        reportee_id: { _in: $reportee_ids }
      }
    ) {
      affected_rows
    }
  }
`;

export const INSERT_ONBOARDING_ASSIST_REQUEST = gql`
  mutation insertAssistRequest(
    $object: onboarding_assist_requests_insert_input!
  ) {
    insert_onboarding_assist_requests_one(object: $object) {
      request_id
    }
  }
`;

export const UPDATE_BUSINESS_BY_OWNER = gql`
  mutation updateBusinesses(
    $owner_id: uuid
    $brand_icon: String
    $brand_logo: String
    $business_name: String
    $ref_code: String
  ) {
    updateBusinesses(
      where: { owner_id: { _eq: $owner_id } }
      _set: {
        brand_icon: $brand_icon
        brand_logo: $brand_logo
        business_name: $business_name
        ref_code: $ref_code
      }
    ) {
      affected_rows
    }
  }
`;

export const INSERT_ANNOUNCEMENT = gql`
  mutation insertAnnouncement(
    $announcement_message: String!
    $created_by: uuid!
    $users: [announcement_user_map_insert_input!]!
  ) {
    insert_announcements(
      objects: {
        created_by: $created_by
        announcement_message: $announcement_message
        announcement_user_maps: { data: $users }
      }
    ) {
      affected_rows
    }
  }
`;

export const UPDATE_PROFILE = gql`
  mutation updateEmployeeDetails(
    $user_id: uuid!
    $user_details: users_set_input!
  ) {
    updateUsersById(pk_columns: { user_id: $user_id }, _set: $user_details) {
      updated_at
    }
  }
`;

export const UPDATE_USER_SHIFTS = gql`
  mutation updateEmployeeDetails(
    $user_id: uuid!
    $shifts: [user_shift_insert_input!]!
  ) {
    delete_user_shift(where: { user_id: { _eq: $user_id } }) {
      affected_rows
    }
    insert_user_shift(objects: $shifts) {
      affected_rows
    }
  }
`;

export const CHANGE_PASSWORD = gql`
  mutation change_password(
    $old_password: String!
    $new_password: String!
    $user_id: String!
  ) {
    change_password(
      old_password: $old_password
      new_password: $new_password
      user_id: $user_id
    ) {
      status
      message
    }
  }
`;

export const INSERT_VACATION = gql`
  mutation insert_user_vacations(
    $end_date: date
    $start_date: date
    $user_id: uuid
    $vacation_reason: String
  ) {
    insert_user_vacations(
      objects: {
        end_date: $end_date
        start_date: $start_date
        user_id: $user_id
        vacation_reason: $vacation_reason
      }
    ) {
      affected_rows
    }
  }
`;
export const UPDATE_VACATION = gql`
  mutation update_user_vacations_by_pk(
    $vacation_id: uuid!
    $end_date: date
    $start_date: date
    $vacation_reason: String
  ) {
    update_user_vacations_by_pk(
      pk_columns: { vacation_id: $vacation_id }
      _set: {
        end_date: $end_date
        start_date: $start_date
        vacation_reason: $vacation_reason
      }
    ) {
      vacation_id
    }
  }
`;
export const FORGOT_PASSWORD = gql`
  mutation forgotPassword($email: String!) {
    forgotPassword(email: $email) {
      message
      status
    }
  }
`;

export const DELETE_VACATION = gql`
  mutation delete_user_vacations($vacation_id: uuid) {
    delete_user_vacations(where: { vacation_id: { _eq: $vacation_id } }) {
      affected_rows
    }
  }
`;

export const UPDATE_ANNOUNCEMENT_READ = gql`
  mutation updateAnnouncementRead($user_id: uuid!, $announcement_id: uuid!) {
    updateDetail: update_announcement_user_map_by_pk(
      pk_columns: { announcement_id: $announcement_id, user_id: $user_id }
      _set: { is_read: true }
    ) {
      announcement_id
    }
  }
`;

export const ASSIGN_TASK = gql`
  mutation assign_task($tasks: [JSON!]!, $user_id: String!) {
    assign_task(tasks: $tasks, user_id: $user_id) {
      message
      status
    }
  }
`;

// export const ADD_CUSTOM_TASK = gql`
//   mutation addCustomTask($task_type: task_types_enum, $description: String) {
//     insert_tasks(
//       objects: {
//         task_type: $task_type
//         is_custom: true
//         description: $description
//       }
//     ) {
//       affected_rows
//       task: returning {
//         task_id
//         task_type
//       }
//     }
//   }
// `;

export const ADD_CUSTOM_TASK = gql`
  mutation addCustomTask(
    $task_type: task_types_enum
    $description: String
    $recurring_end_date: date = null
    $recurring_start_date: date = null
    $task_recurring_type: task_recurring_types_enum = null
    $task_json: jsonb = ""
  ) {
    insert_tasks(
      objects: {
        task_type: $task_type
        is_custom: true
        description: $description
        recurring_end_date: $recurring_end_date
        recurring_start_date: $recurring_start_date
        task_recurring_type: $task_recurring_type
        task_json: $task_json
      }
    ) {
      affected_rows
      task: returning {
        task_id
        task_type
        recurring_end_date
        recurring_start_date
        task_json
      }
    }
  }
`;

export const UPDATE_CUSTOM_TASK = gql`
  mutation updateCustomTask(
    $task_id: uuid!
    $task_type: task_types_enum!
    $description: String!
    $recurring_end_date: date = ""
    $recurring_start_date: date = ""
    $task_json: jsonb = []
    $task_recurring_type: task_recurring_types_enum = daily
  ) {
    update_tasks_by_pk(
      pk_columns: { task_id: $task_id }
      _set: {
        task_type: $task_type
        description: $description
        recurring_end_date: $recurring_end_date
        recurring_start_date: $recurring_start_date
        task_json: $task_json
        task_recurring_type: $task_recurring_type
      }
    ) {
      task_id
      task_json
      task_type
      recurring_end_date
      recurring_start_date
    }
  }
`;

export const DELETE_CUSTOM_TASK = gql`
  mutation deleteCustomTask($task_id: uuid!) {
    update_tasks_by_pk(
      pk_columns: { task_id: $task_id }
      _set: { is_deleted: true }
    ) {
      task_id
    }
  }
`;

export const INSERT_CUSTOM_TASK_TUTORIAL = gql`
  mutation insertTutorial(
    $tutorial_type: tutorial_types_enum
    $tutorial_url: String
    $task_id: uuid
  ) {
    insert_tutorials(
      objects: {
        tutorial_type: $tutorial_type
        tutorial_url: $tutorial_url
        task_tutorial_maps: { data: { task_id: $task_id } }
      }
    ) {
      affected_rows
    }
  }
`;

export const UPDATE_CUSTOM_TASK_TUTORIAL = gql`
  mutation updateTutorial(
    $tutorial_id: uuid!
    $tutorial_url: String!
    $tutorial_type: tutorial_types_enum!
  ) {
    update_tutorials_by_pk(
      pk_columns: { tutorial_id: $tutorial_id }
      _set: { tutorial_url: $tutorial_url, tutorial_type: $tutorial_type }
    ) {
      tutorial_id
    }
  }
`;

export const DELETE_ASSIGNED_TUTORIAL = gql`
  mutation deleteAssignedTutorial($task_id: uuid!) {
    delete_task_tutorial_map(where: { task_id: { _eq: $task_id } }) {
      affected_rows
    }
  }
`;

export const UPDATE_TASK_STATUS = gql`
  mutation update_user_tasks_status(
    $user_id: uuid
    $task_id: uuid
    $task_status: user_tasks_status_enum
    $note: String
    $task_status_updated_at: timestamptz
  ) {
    update_user_tasks_map(
      where: { user_id: { _eq: $user_id }, task_id: { _eq: $task_id } }
      _set: {
        task_status: $task_status
        note: $note
        task_status_updated_at: $task_status_updated_at
      }
    ) {
      affected_rows
      returning {
        task_status
        task_id
        note
      }
    }
  }
`;

export const UPDATE_TASK_STATUS_WITH_FILES_INSERT = gql`
  mutation updateTaskStatus(
    $user_id: uuid
    $user_task_id: uuid
    $note: String
    $objects: [task_files_insert_input!]!
  ) {
    update_user_tasks_map(
      where: {
        _and: {
          user_task_id: { _eq: $user_task_id }
          task_status: { _eq: pending }
        }
      }
      _set: {
        task_status: completed
        task_status_updated_by: $user_id
        task_status_updated_at: "now()"
        note: $note
      }
    ) {
      affected_rows
    }
    insert_task_files(objects: $objects) {
      affected_rows
    }
  }
`;
export const UPSERT_USER_SHIFT = gql`
  mutation upsert_user_shift($objects: [user_shift_insert_input!]!) {
    insert_user_shift(
      on_conflict: {
        constraint: user_shift_pkey
        update_columns: [user_id, start_time, end_time, working_day]
      }
      objects: $objects
    ) {
      affected_rows
      returning {
        user_id
      }
    }
  }
`;

export const UPDATE_USER_TASK_NOTIFICATION = gql`
  mutation update_notification_users($user_id: uuid, $notification_id: uuid) {
    update_notification_users(
      where: {
        user_id: { _eq: $user_id }
        notification_id: { _eq: $notification_id }
      }
      _set: { is_read: true }
    ) {
      returning {
        is_read
      }
    }
  }
`;

export const VERIFY_EMAIL = gql`
  mutation verifyEmail($token: String!) {
    verify_email(token: $token) {
      message
      status
    }
  }
`;

export const CANCEL_SUBSCRIPTION = gql`
  mutation cancelSubscription {
    cancel_subscription {
      message
      returning
      status
    }
  }
`;

export const UPDATE_SUBSCRIPTION = gql`
  mutation updateSubscription(
    $locations: Float!
    $price_id: String!
    $status: String!
  ) {
    update_subscription(
      locations: $locations
      price_id: $price_id
      state: $status
    ) {
      message
      returning
      status
    }
  }
`;
export const ADD_CARD = gql`
  mutation addCard($stripe_data: [JSON!]!) {
    add_card(stripe_data: $stripe_data) {
      status
      returning
      message
    }
  }
`;

export const UPDATE_SUBSCRIPTION_ON_LOCATION = gql`
  mutation updateSubscription($locations: Float!, $price_id: String!) {
    update_subscription_on_location(
      locations: $locations
      price_id: $price_id
    ) {
      message
      returning
      status
    }
  }
`;

export const REPLACE_CARD = gql`
  mutation replaceCard($stripe_data: [JSON!]!) {
    replace_card(stripe_data: $stripe_data) {
      status
      returning
      message
    }
  }
`;
